<template>
    <v-col :cols="cols">
        <div class="d-flex">
            <div class="subtitle-1 font-weight-bold">{{ text }}</div>
            <div class="flex-grow-1 section-line">
                <div class="ml-4"></div>
            </div>
        </div>
    </v-col>
</template>

<script>
export default {
    name: 'DetailFormSection',

    props: {
        text: {
            type: String,
            default: ''
        },

        cols: {
            type: [Number, String],
            default: 12
        }
    }
}
</script>

<style lang="scss" scoped>
.section-line {
    align-self: center;
    & > div {
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 1px;
    }
}
</style>
